import axios from 'axios'

const API_PREFIX = 'cedis-productos-precios'

const ENDPOINTS = {
    graficaHistorialPrecios: (payload,params = {}) => axios(`${API_PREFIX}/${payload.id_producto}/${payload.id_cedis}/grafica-historial`,{params}),
};

export default ENDPOINTS
